import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vModelCheckbox as _vModelCheckbox, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, withModifiers as _withModifiers, Transition as _Transition, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../../assets/img/arrow-bottom.svg'
import _imports_1 from '../../assets/img/arrow-top.svg'


const _withScopeId = n => (_pushScopeId("data-v-7da8baa8"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", { class: "views_title" }, "Welcome to bulling part", -1))
const _hoisted_2 = { class: "periods" }
const _hoisted_3 = { id: "filters_div" }
const _hoisted_4 = { id: "select_periods" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "Sélectionner une date :", -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "start_period_date" }, "Du ", -1))
const _hoisted_7 = ["value"]
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "end_period_date" }, " au ", -1))
const _hoisted_9 = ["value"]
const _hoisted_10 = { id: "actions" }
const _hoisted_11 = {
  key: 1,
  id: "div_checked_periods_all_actions"
}
const _hoisted_12 = { id: "checkall_checkbox" }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "checkAll" }, " Tout sélectionner", -1))
const _hoisted_14 = { class: "checkbox_structure" }
const _hoisted_15 = ["id", "onUpdate:modelValue", "checked", "onChange"]
const _hoisted_16 = ["for"]
const _hoisted_17 = ["onClick"]
const _hoisted_18 = ["onClick"]
const _hoisted_19 = {
  key: 0,
  class: "data"
}
const _hoisted_20 = { class: "data_period" }
const _hoisted_21 = { key: 0 }
const _hoisted_22 = { key: 1 }
const _hoisted_23 = ["onClick"]
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", null, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_NavView = _resolveComponent("NavView")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_NavView),
    _hoisted_1,
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _hoisted_5,
          _hoisted_6,
          _createElementVNode("input", {
            onChange: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.update_date_filter && _ctx.update_date_filter(...args))),
            type: "date",
            name: "start_period_date",
            id: "start_period_date",
            min: "2021-01-01",
            max: "2050-12-31",
            value: _ctx.startPeriodDate
          }, null, 40, _hoisted_7),
          _hoisted_8,
          _createElementVNode("input", {
            onChange: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.update_date_filter && _ctx.update_date_filter(...args))),
            type: "date",
            name: "end_period_date",
            id: "end_period_date",
            value: _ctx.endPeriodDate
          }, null, 40, _hoisted_9)
        ]),
        _createElementVNode("div", _hoisted_10, [
          (_ctx.checkedPeriods.length !== 0)
            ? (_openBlock(), _createElementBlock("button", {
                key: 0,
                onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.checkedPeriodsAllActions = !_ctx.checkedPeriodsAllActions))
              }, "Plus d'actions"))
            : _createCommentVNode("", true),
          (_ctx.checkedPeriodsAllActions && _ctx.checkedPeriods.length !== 0)
            ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                _createElementVNode("p", {
                  onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.get_a_download_of_the_CA_summary_of_the_period()))
                }, "Télécharger un résumé de CA"),
                _createElementVNode("p", {
                  onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.get_a_download_of_all_invoices_of_the_period()))
                }, "Télécharger toutes les factures"),
                _createElementVNode("p", {
                  onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.get_a_download_of_des_of_the_period()))
                }, "Télécharger fichier des")
              ]))
            : _createCommentVNode("", true)
        ])
      ]),
      _createElementVNode("div", _hoisted_12, [
        _withDirectives(_createElementVNode("input", {
          type: "checkbox",
          name: "checkAll",
          id: "checkAll",
          "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.selectAll) = $event)),
          onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.selectAll = !_ctx.selectAll)),
          onChange: _cache[8] || (_cache[8] = 
//@ts-ignore
(...args) => (_ctx.updateCheckAllPeriods && _ctx.updateCheckAllPeriods(...args)))
        }, null, 544), [
          [_vModelCheckbox, _ctx.selectAll]
        ]),
        _hoisted_13
      ]),
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.debitPeriods, (period, index) => {
        return (_openBlock(), _createElementBlock("div", {
          key: period.periodData.nextDebitTimeStamp,
          class: "period"
        }, [
          _createElementVNode("div", _hoisted_14, [
            _withDirectives(_createElementVNode("input", {
              type: "checkbox",
              name: "checkbox_period",
              id: 'checkbox_' + index,
              class: "checkboxPeriod",
              "onUpdate:modelValue": ($event: any) => ((period.isChecked) = $event),
              checked: _ctx.checkedPeriods.includes(period.periodData.nextDebitTimeStamp),
              onChange: ($event: any) => (_ctx.updatecheckedPeriods(period.periodData.nextDebitTimeStamp))
            }, null, 40, _hoisted_15), [
              [_vModelCheckbox, period.isChecked]
            ]),
            _createElementVNode("label", {
              for: 'checkbox_' + index
            }, " Période du " + _toDisplayString(_ctx.timestamp_to_date(period.periodData.startDebitPeriodTimeStamp, "dd/mm/yyyy")) + " au " + _toDisplayString(_ctx.timestamp_to_date(period.periodData.endDebitPeriodTimeStamp, "dd/mm/yyyy")), 9, _hoisted_16),
            (!period.showPeriodContent)
              ? (_openBlock(), _createElementBlock("img", {
                  key: 0,
                  src: _imports_0,
                  alt: "bottom_arrow",
                  onClick: ($event: any) => (period.showPeriodContent = !period.showPeriodContent)
                }, null, 8, _hoisted_17))
              : _createCommentVNode("", true),
            (period.showPeriodContent)
              ? (_openBlock(), _createElementBlock("img", {
                  key: 1,
                  src: _imports_1,
                  alt: "top_arrow",
                  onClick: ($event: any) => (period.showPeriodContent = !period.showPeriodContent)
                }, null, 8, _hoisted_18))
              : _createCommentVNode("", true)
          ]),
          _createVNode(_Transition, { name: "fade" }, {
            default: _withCtx(() => [
              (period.showPeriodContent)
                ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
                    _createElementVNode("div", _hoisted_20, [
                      _createElementVNode("h4", null, "Total CA : " + _toDisplayString(period.periodData.totalPeriodCa), 1),
                      _createElementVNode("p", null, "Total CA TTC FR : " + _toDisplayString(period.periodData.totalPeriodCaTtcFr), 1),
                      _createElementVNode("p", null, "Total CA HT FR : " + _toDisplayString(period.periodData.totalPeriodCaHtFr), 1),
                      _createElementVNode("p", null, "Total TVA FR : " + _toDisplayString(period.periodData.totalPeriodAmountTvaFr), 1),
                      _createElementVNode("p", null, "Total CA EU : " + _toDisplayString(period.periodData.totalPeriodCaEuHt), 1)
                    ]),
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(period.invoices, (invoice) => {
                      return (_openBlock(), _createElementBlock("ul", {
                        key: invoice.invoiceNumber,
                        class: "seller_invoices"
                      }, [
                        _createElementVNode("li", null, _toDisplayString(invoice.techName), 1),
                        _createElementVNode("li", null, "Numéro de facture : " + _toDisplayString(invoice.invoiceNumber), 1),
                        (invoice.totalAmountTtc !== undefined)
                          ? (_openBlock(), _createElementBlock("li", _hoisted_21, "Total TTC : " + _toDisplayString(invoice.totalAmountTtc), 1))
                          : _createCommentVNode("", true),
                        _createElementVNode("li", null, "Total HT : " + _toDisplayString(invoice.totalAmountHt), 1),
                        (invoice.totalAmountTva !== undefined)
                          ? (_openBlock(), _createElementBlock("li", _hoisted_22, "Total TVA : " + _toDisplayString(invoice.totalAmountTva), 1))
                          : _createCommentVNode("", true),
                        _createElementVNode("a", {
                          href: "#",
                          onClick: _withModifiers(($event: any) => (_ctx.get_billing_downloading(invoice.techName ,invoice.invoiceNumber)), ["prevent"])
                        }, "Télécharger la facture", 8, _hoisted_23)
                      ]))
                    }), 128))
                  ]))
                : _createCommentVNode("", true)
            ]),
            _: 2
          }, 1024),
          _hoisted_24
        ]))
      }), 128))
    ])
  ], 64))
}